import { apiFetch } from '../client';
import type {
    ApiUserAccessLocal,
    ApiUserCredentialsLocal,
    CreateApiUserRequestLocal,
    CreateApiUserResponseLocal,
    UpdateApiUserAccessRequestLocal,
} from '../types/TenantLocal';

/** Usuarios de API del tenant. Mismo backend para el flujo tenant y el drill-down de plataforma. */
export const apiUserApi = {
    create: (tid: string, body: CreateApiUserRequestLocal, opts: { idempotencyKey: string }) =>
        apiFetch<CreateApiUserResponseLocal>(`/tenants/${tid}/users`, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: { 'Idempotency-Key': opts.idempotencyKey },
        }),
    rotateSecret: (tid: string, cognitoSub: string) =>
        apiFetch<ApiUserCredentialsLocal>(`/tenants/${tid}/users/${cognitoSub}/api-secret/rotate`, {
            method: 'POST',
        }),
    updateAccess: (tid: string, cognitoSub: string, body: UpdateApiUserAccessRequestLocal) =>
        apiFetch<ApiUserAccessLocal>(`/tenants/${tid}/users/${cognitoSub}/api-access`, {
            method: 'PUT',
            body: JSON.stringify(body),
        }),
};
